/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'ai-mate.chat-error-banner.description': 'Vaše historie chatu je uložena na 30 dní.',
  'ai-mate.chat-error-banner.title': 'Zahájit nový chat',
  'ai-mate.chat-error.description': 'Zkuste <btn>znovu načíst chat</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Dosáhli jste maximálního počtu žádostí. Zkuste to znovu později.',
  'ai-mate.chat-error.rate-limited-title': 'Příliš mnoho žádostí',
  'ai-mate.chat-error.rovo-inactive-description':
    'Zdá se, že nástroj Rovo není na vašem webu zapnutý. <link>Nastavení nástroje Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Nástroj Rovo není aktivní',
  'ai-mate.chat-error.title': 'Nejsme si jistí, kde se stala chyba',
  'ai-mate.main-chat.close-chat-button-label': 'Zavřít',
  'ai-mate.main-chat.maximize-chat-button-label': 'Celá obrazovka',
  'ai-mate.main-chat.minimize-chat-button-label': 'Obnovit zobrazení',
  'ai-mate.main-chat.new-chat-button-label': 'Nové',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nový chat',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Odeslat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Zeptejte se na to AI.',
  'highlight-actions.rovo-chat-explain-option.text': 'Vysvětlit',
  'highlight-actions.rovo-chat-explain-prompt':
    'Vysvětlete to přeformulováním a přidáním dalších podrobností, ale používejte velmi jednoduchý jazyk a krátké věty a uveďte příklady nebo definice veškeré technické terminologie používané v původní formulaci.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Najít zdroje',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Najděte v rámci znalostí organizace pouze takové zdroje, které podporují učiněná prohlášení.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Uvést příklady',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Uveďte příklady ze zdrojů organizace nebo veřejných znalostí. Pokud neexistují žádné zdroje, které byste mohli poskytnout, zkuste uvést metaforický příklad, který by mohl pomoci lépe tomu porozumět.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Poskytnout zpětnou vazbu',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Poskytněte zpětnou vazbu tím, že zkontrolujete formulaci. Poskytněte komentář k výběru slov, gramatice, interpunkci. Buďte pozitivní a energičtí, ale vždy uveďte alespoň jednu věc, kterou by šlo zlepšit nebo změnit.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Doporučení chatu',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Otevřít chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Shrnout',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Zvýrazněte klíčové body. Zaměřte se na základní informace a vylučte zbytečné podrobnosti. Poskytněte stručný přehled v jediném odstavci.',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Zeptat se v chatu',
  'horizontal-scroll-container.scroll-left': 'Posunout doleva',
  'horizontal-scroll-container.scroll-right': 'Posunout doprava',
};
